import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft, KeyRound } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import { changePassword } from '../utils/api';

const ChangePassword = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 8) { toast.error('New password must be at least 8 characters'); return; }
    if (form.next !== form.confirm) { toast.error('New password and confirmation do not match'); return; }
    setSaving(true);
    try {
      await changePassword(form.current, form.next);
      toast.success('Password changed successfully');
      setForm({ current: '', next: '', confirm: '' });
      setTimeout(() => navigate('/admin/dashboard'), 800);
    } catch (err) {
      toast.error(err.message || 'Could not change password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4">
      <div className="max-w-md mx-auto" data-testid="change-password-page">
        <Link to="/admin/dashboard">
          <Button variant="outline" size="sm" className="mb-6"><ArrowLeft size={16} className="mr-2" /> Back to Dashboard</Button>
        </Link>
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2"><KeyRound className="text-blue-600" size={22} /> Change Password</CardTitle>
            <p className="text-sm text-slate-600">Update the password for your own account.</p>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="current">Current Password</Label>
                <Input id="current" type="password" value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })} required data-testid="current-password" />
              </div>
              <div>
                <Label htmlFor="next">New Password</Label>
                <Input id="next" type="password" value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })} placeholder="At least 8 characters" required data-testid="new-password" />
              </div>
              <div>
                <Label htmlFor="confirm">Confirm New Password</Label>
                <Input id="confirm" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required data-testid="confirm-password" />
              </div>
              <Button type="submit" disabled={saving} className="bg-blue-600 hover:bg-blue-700 w-full" data-testid="submit-change-password">
                {saving ? 'Saving…' : 'Change Password'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ChangePassword;
